import React from 'react';
import Navigation from '../Common/Navigation';
import { NavLink } from 'react-router-dom';

var bnr = require('./../../images/background/bg-5.png');

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            themeLogo: require('./../../images/logo-dark.png'), // Default colored logo
            isSearchActive: false,
            isQuoteActive: false,
            isMobileNavOpen: false,
            isScrolled: false
        };
        this.mainBarRef = React.createRef();
    }

    handleSearchToggle = () => {
        this.setState({ isSearchActive: !this.state.isSearchActive });
    };

    handleQuoteToggle = () => {
        this.setState({ isQuoteActive: !this.state.isQuoteActive });
    };

    handleMobileNavToggle = () => {
        this.setState((prevState) => ({ isMobileNavOpen: !prevState.isMobileNavOpen }));
    };

    closeMobileNav = () => {
        this.setState({ isMobileNavOpen: false });
    };

    componentDidMount() {
        const mainBar = this.mainBarRef.current;

        const handleScroll = () => {
            const offset = window.scrollY;
            const stickyheader = document.querySelector('.sticky-header ');
            const isScrolled = offset >= 100;

            if (this.state.isScrolled !== isScrolled) {
                this.setState({ isScrolled });
            }

            if (isScrolled) {
                stickyheader.classList.add('is-fixed');
                stickyheader.classList.add('color-fill');
                if (mainBar) {
                    mainBar.style.background = '#fff';
                    mainBar.style.boxShadow = '0 2px 12px rgba(0,0,0,0.10)';
                }
            } else {
                stickyheader.classList.remove('is-fixed');
                stickyheader.classList.remove('color-fill');
                if (mainBar) {
                    mainBar.style.background = 'transparent';
                    mainBar.style.boxShadow = 'none';
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        window.updateTopMostParent = (logopath) => {
            this.setState({ themeLogo: logopath });
        };
    }

    render() {
        const { isSearchActive, isQuoteActive, isMobileNavOpen } = this.state;
        const activeLogo = (this.props.transparent && !this.state.isScrolled) ? require('./../../images/logo-dark.png') : this.state.themeLogo;

        return (
            <>
                {this.props.transparent && <style>{`
                    /* Float the entire header over the video */
                    .site-header.header-style-1 {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        z-index: 999;
                    }
                    /* Top-bar text white over video */
                    .site-header.header-style-1 .top-bar .e-p-bx li,
                    .site-header.header-style-1 .top-bar .e-p-bx li i {
                        color: #fff !important;
                    }
                    /* Nav links white over video */
                    .header-style-1 .header-nav .nav > li > a {
                        color: #fff !important;
                        text-shadow: 0 1px 4px rgba(0,0,0,0.4);
                    }
                    .header-style-1 .extra-nav a i {
                        color: #fff !important;
                    }
                    /* Restore dark links when scrolled (is-fixed adds position:fixed) */
                    .header-style-1 .is-fixed.color-fill .header-nav .nav > li > a {
                        color: #000 !important;
                        text-shadow: none;
                    }
                `}</style>}
                <style>{`

                    /* ===== MOBILE NAV STYLES ===== */
                    .mobile-nav-overlay {
                        display: none;
                        position: fixed;
                        inset: 0;
                        background: rgba(0,0,0,0.5);
                        z-index: 9998;
                        backdrop-filter: blur(2px);
                    }
                    .mobile-nav-overlay.open {
                        display: block;
                    }
                    .mobile-nav-drawer {
                        position: fixed;
                        top: 0;
                        left: -280px;
                        width: 280px;
                        height: 100vh;
                        background: #0d1b2a;
                        z-index: 9999;
                        transition: left 0.3s cubic-bezier(0.4,0,0.2,1);
                        display: flex;
                        flex-direction: column;
                        box-shadow: 4px 0 24px rgba(0,0,0,0.4);
                        overflow-y: auto;
                    }
                    .mobile-nav-drawer.open {
                        left: 0;
                    }
                    .mobile-nav-drawer .drawer-header {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 16px 20px;
                        border-bottom: 1px solid rgba(255,255,255,0.1);
                    }
                    .mobile-nav-drawer .drawer-header img {
                        height: 56px;
                        width: auto;
                        max-width: 180px;
                        object-fit: contain;
                    }
                    .mobile-nav-drawer .drawer-close {
                        background: none;
                        border: none;
                        color: #fff;
                        font-size: 24px;
                        cursor: pointer;
                        padding: 4px 8px;
                        line-height: 1;
                        opacity: 0.8;
                        transition: opacity 0.2s;
                    }
                    .mobile-nav-drawer .drawer-close:hover { opacity: 1; }
                    .mobile-nav-drawer nav ul {
                        list-style: none;
                        margin: 0;
                        padding: 12px 0;
                    }
                    .mobile-nav-drawer nav ul li a {
                        display: block;
                        padding: 14px 24px;
                        color: rgba(255,255,255,0.88) !important;
                        font-size: 15px;
                        font-weight: 500;
                        font-family: 'Poppins', sans-serif;
                        text-decoration: none !important;
                        border-left: 3px solid transparent;
                        transition: background 0.2s, border-color 0.2s, color 0.2s;
                        letter-spacing: 0.02em;
                    }
                    .mobile-nav-drawer nav ul li a:hover,
                    .mobile-nav-drawer nav ul li a.active {
                        background: rgba(255,255,255,0.08);
                        border-left-color: #fff;
                        color: #fff !important;
                    }
                    .mobile-nav-drawer .drawer-footer {
                        margin-top: auto;
                        padding: 20px 24px;
                        border-top: 1px solid rgba(255,255,255,0.1);
                    }
                        display: block;
                        text-align: center;
                        padding: 12px;
                        color: #000 !important;
                        font-weight: 700;
                        font-size: 14px;
                        border-radius: 4px;
                        text-decoration: none !important;
                        letter-spacing: 0.05em;
                        text-transform: uppercase;
                    }
                    .mobile-nav-drawer .drawer-contact-info {
                        padding: 16px 24px 0;
                    }
                    .mobile-nav-drawer .drawer-contact-info p {
                        color: rgba(255,255,255,0.55);
                        font-size: 12px;
                        margin: 4px 0;
                    }
                    .mobile-nav-drawer .drawer-contact-info p i {
                        margin-right: 8px;
                    }

                    /* Hide default Bootstrap hamburger on mobile — we use custom one */
                    @media (max-width: 767px) {
                        .navbar-toggle { display: none !important; }
                        .header-nav { display: none !important; }
                        .mobile-menu-btn { display: flex !important; }
                    }
                    @media (min-width: 768px) {
                        .mobile-menu-btn { display: none !important; }
                        .mobile-nav-drawer, .mobile-nav-overlay { display: none !important; }
                    }
                    .mobile-menu-btn {
                        display: none;
                        background: none;
                        border: none;
                        cursor: pointer;
                        padding: 6px;
                        flex-direction: column;
                        gap: 5px;
                        align-items: center;
                        justify-content: center;
                        margin-left: auto;
                    }
                    .mobile-menu-btn .bar {
                        display: block;
                        width: 24px;
                        height: 2px;
                        background: #fff;
                        border-radius: 2px;
                        transition: background 0.3s;
                    }
                    .is-fixed .mobile-menu-btn .bar {
                        background: #222;
                    }
                `}</style>

                {/* Mobile Nav Overlay */}
                <div
                    className={`mobile-nav-overlay${isMobileNavOpen ? ' open' : ''}`}
                    onClick={this.closeMobileNav}
                />

                {/* Mobile Nav Drawer */}
                <div className={`mobile-nav-drawer${isMobileNavOpen ? ' open' : ''}`}>
                    <div className="drawer-header">
                        <img src={require('./../../images/logo-light.png')} alt="Buildco" style={{ filter: 'brightness(0) invert(1)' }} />
                        <button className="drawer-close" onClick={this.closeMobileNav}>×</button>
                    </div>
                    <nav>
                        <ul>
                            <li><NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''} onClick={this.closeMobileNav}>Home</NavLink></li>
                            <li><NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''} onClick={this.closeMobileNav}>Who We Are</NavLink></li>
                            <li><NavLink to="/services" className={({ isActive }) => isActive ? 'active' : ''} onClick={this.closeMobileNav}>Services</NavLink></li>
                            <li><NavLink to="/blog-masonary" className={({ isActive }) => isActive ? 'active' : ''} onClick={this.closeMobileNav}>News &amp; Insights</NavLink></li>
                            <li><NavLink to="/project-classic2" className={({ isActive }) => isActive ? 'active' : ''} onClick={this.closeMobileNav}>Projects</NavLink></li>
                            <li><NavLink to="/contactus" className={({ isActive }) => isActive ? 'active' : ''} onClick={this.closeMobileNav}>Contact Us</NavLink></li>
                        </ul>
                    </nav>
                    <div className="drawer-contact-info">
                        <p><i className="fa fa-phone" />  (031) 3877-7888</p>
                        <p><i className="fa fa-envelope" /> buildcoint@gmail.com</p>
                    </div>
                    <div className="drawer-footer">
                        <a
                            href="https://wa.me/923335196170?text=Hello! I would like to make an appointment."
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={this.closeMobileNav}
                            className="site-button"
                            style={{ width: '100%', marginBottom: '10px' }}
                        >
                            <i className="fa fa-whatsapp" style={{ marginRight: '8px', fontSize: '18px' }} />
                            WhatsApp Us
                        </a>
                    </div>
                </div>

                <header className="site-header header-style-1">
                    <div className="top-bar" style={this.props.transparent ? { background: 'transparent', borderBottom: '1px solid rgba(255,255,255,0.15)' } : {}}>
                        <div className="container">
                            <div className="row">
                                <div className="mt-topbar-left clearfix">
                                    <ul className="list-unstyled e-p-bx pull-right">
                                        <li><i className="fa fa-envelope" /> buildcoint@gmail.com</li>
                                        <li><i className="fa fa-phone" />(031) 3877-7888</li>
                                        <li><i className="fa fa-clock-o" />Mon-Sat 9.00 am to 6.00pm</li>
                                    </ul>
                                </div>
                                <div className="mt-topbar-right clearfix">
                                    <div className="appint-btn">
                                        <a
                                            href="https://wa.me/923335196170?text=Hello! I would like to make an appointment for interior design services."
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="site-button"
                                        >
                                            Contact on Whatsapp
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sticky-header main-bar-wraper">
                        <div
                            className="main-bar"
                            ref={this.mainBarRef}
                            style={this.props.transparent ? { background: 'transparent', boxShadow: 'none', transition: 'background 0.3s ease, box-shadow 0.3s ease' } : { transition: 'background 0.3s ease, box-shadow 0.3s ease' }}
                        >
                            <div className="container">
                                <div className="logo-header">
                                    <div className="logo-header-inner logo-header-one">
                                        <NavLink to={"/"}>
                                            <img src={activeLogo} alt="Buildco" />
                                        </NavLink>
                                    </div>
                                </div>

                                {/* Custom Mobile Hamburger */}
                                <button
                                    className="mobile-menu-btn"
                                    onClick={this.handleMobileNavToggle}
                                    aria-label="Toggle navigation"
                                >
                                    <span className="bar" />
                                    <span className="bar" />
                                    <span className="bar" />
                                </button>

                                {/* EXTRA Nav (desktop only) */}
                                <div className="extra-nav">
                                    <div className="extra-cell">
                                        <NavLink to={"#"} onClick={this.handleSearchToggle}>
                                            <i className="fa fa-search" />
                                        </NavLink>
                                    </div>
                                    <div className="extra-cell">
                                        <NavLink to={"#"} className="contact-slide-show" onClick={this.handleQuoteToggle}><i className="fa fa-angle-left arrow-animation" /></NavLink>
                                    </div>
                                </div>
                                {/* Contact Nav */}
                                <div className="contact-slide-hide " style={{ backgroundImage: 'url(' + bnr + ')', right: isQuoteActive ? '0px' : '-500px' }}>
                                    <div className="contact-nav">
                                        <NavLink to={"#"} className="contact_close" onClick={this.handleQuoteToggle}>×</NavLink>
                                        <div className="contact-nav-form p-a30">
                                            <div className="contact-info   m-b30">
                                                <div className="mt-icon-box-wraper center p-b30">
                                                    <div className="icon-xs m-b20 scale-in-center"><i className="fa fa-phone" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0 font-weight-500">Phone number</h5>
                                                        <p>(031) 3877-7888</p>
                                                    </div>
                                                </div>
                                                <div className="mt-icon-box-wraper center p-b30">
                                                    <div className="icon-xs m-b20 scale-in-center"><i className="fa fa-envelope" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0 font-weight-500">Email address</h5>
                                                        <p>buildcoint@gmail.com</p>
                                                    </div>
                                                </div>
                                                <div className="mt-icon-box-wraper center p-b30">
                                                    <div className="icon-xs m-b20 scale-in-center"><i className="fa fa-map-marker" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0 font-weight-500">Address info</h5>
                                                        <p>2nd Floor Main Boulevard
                                                            DHA Ph-2
                                                            Islamabad, Pakistan</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="full-social-bg">
                                                <ul>
                                                    <li><NavLink to={"#"} className="facebook"><i className="fa fa-facebook" /></NavLink></li>
                                                    <li><NavLink to={"#"} className="google"><i className="fa fa-google" /></NavLink></li>
                                                    <li><NavLink to={"#"} className="instagram"><i className="fa fa-instagram" /></NavLink></li>
                                                    <li><NavLink to={"#"} className="tumblr"><i className="fa fa-tumblr" /></NavLink></li>
                                                    <li><NavLink to={"#"} className="twitter"><i className="fa fa-twitter" /></NavLink></li>
                                                    <li><NavLink to={"#"} className="youtube"><i className="fa fa-youtube" /></NavLink></li>
                                                </ul>
                                            </div>
                                            <div className="text-center">
                                                <h4 className="font-weight-600">© Buildco Associates</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* SITE Search */}
                                <div id="search" className={isSearchActive ? "open" : ""}>
                                    <span className="close" onClick={this.handleSearchToggle} />
                                    <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                                        <div className="input-group">
                                            <input defaultValue="" name="q" type="search" placeholder="Type to search" />
                                            <span className="input-group-btn"><button type="button" className="search-btn"><i className="fa fa-search arrow-animation" /></button></span>
                                        </div>
                                    </form>
                                </div>
                                {/* MAIN Nav */}
                                <Navigation />
                            </div>
                        </div>
                    </div>
                </header>

            </>
        );
    };
};

export default Header;
